<footer class="footer">
    <div class="footer-top">
      @for (contextKey of (groupedFooterNav | keyvalue); track $index) {
        <div class="footer-col">
          <h4>{{ contextKey.key | translate }}</h4>
          <div class="footer-quick-links">
            @for (item of contextKey.value; track $index) {
              <a [routerLink]="item.url" class="nav-link" [title]="item.title | translate">{{ item.name | translate }}</a>
            }
          </div>
        </div>
      }
      <div class="footer-col">
        <h4>{{ 'follow_us' | translate }}</h4>
        <div class="footer-socials">
            @for (social of socialIcons | keyvalue; track $index) {
                @if (social.value) {
                    <a [href]="social.value" target="_blank" [attr.aria-label]="social.key" [attr.title]="social.key">
                        <img [src]="'/svg/social/' + social.key + '.svg'" height="32"/>
                    </a>
                }
            }
        </div>
      </div>
    </div>
    <div class="footer-divider"></div>
    <div class="footer-bottom">
      <div class="footer-copyright">
        <span>&copy; {{ 'copyright_txt' | translate: {year: currentYear} }}</span>
      </div>
      <div class="footer-icons">
        <div class="footer-legal">
          @for (legalIcon of legalIcons; track $index) {
            <img [src]="legalIcon.src" [alt]="legalIcon.alt" height="32" />
          }
        </div>
        <div class="footer-payments">
            @for (payment of paymentProviders; track $index) {
                <img [src]="payment.src" [alt]="payment.title" height="32" />
            }
        </div>
      </div>
    </div>
  </footer>